// extracted by mini-css-extract-plugin
export default {"container":"detail_container__eENT0"};